import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=ba1cc65a&scoped=true&"
import script from "./BurgerMenu.vue?vue&type=script&lang=js&"
export * from "./BurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=ba1cc65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1cc65a",
  null
  
)

export default component.exports